import { Button, Typography } from '@cobliteam/ui/components';

import Icon from '@cobliteam/ui/icons';

import SidebarButtonPreview from '../assets/sidebar_button_preview.png';

export interface GlobalFilterTooltipComponentProps {
  stepIndex: number;
  totalSteps: number;
  closeFloater: () => void;
}

export default function GlobalFilterTooltipComponent({ stepIndex, totalSteps, closeFloater }: GlobalFilterTooltipComponentProps) {
  return (
    <>
      <div className='flex w-[38rem] flex-row items-center gap-5'>
        <Button variant='text' color='default' className='absolute top-6 right-6' icon={<Icon name='x' />} onClick={closeFloater} />
        <img src={SidebarButtonPreview} className='h-18 w-64' alt='Filtro Global' />
        <div className='flex flex-col gap-3'>
          <Typography variant='description-title'>Conheça o novo filtro de grupos de veículos!</Typography>
          <Typography variant='description-list-default'>
            Agora você pode filtrar mais fácil seus grupos com o novo filtro! O grupo filtrado irá refletir em todas as páginas do painel.
          </Typography>
          <div className='flex flex-row items-center justify-between'>
            <Typography variant='description-list-default' color='secondary'>
              {`${stepIndex} de ${totalSteps}`}
            </Typography>
            <Button onClick={closeFloater}>Concluir</Button>
          </div>
        </div>
      </div>
    </>
  );
}
